import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "react-localize-redux";
import moment from 'moment'

/** Import component section */
import withauthenticatedLayout from '../../layouts/withauthenticatedLayout';

/** Material-UI imports section */
import Typography from "@material-ui/core/Typography";
import Avatar from '@material-ui/core/Avatar';
import DevolutionIcon from '@material-ui/icons/ReplyAllOutlined'; 

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import Toaster from '../../common/Toaster';
import LoadingPage from '../../common/LoadingPage';
import DevolutionForm from './DevolutionForm';

import {loadRawMaterialNonConformityFromBackEnd, createDevolutionFromBackEnd} from '../../../store/rawMaterialNonConformity/RawMaterialActions';

/**
 * Component to create corrective action supplier
 */
class Create extends Component{

     /**
     * Create an instance ofMemos
     * @param {*} props 
     */
    constructor(props){
        super(props);
        autoBind(this);
        this.state = {
            showToaster: false,
            toasterMessage: null,
            toasterVariant: "",
            creationDate: moment().format('DD/MM/YYYY'),
        }
    }

       /**
     * componentDidMount
     */
    componentDidMount(){
        let rawMaterialToken = this.props.match.params.token;
        this.props.loadRawMaterialNonConformity(rawMaterialToken);
    }

    /**
     * Get action to create devolution from raw mateiral 
     */
    createDevolutionFromRawMaterialNononformity(preparedBy, failure, devolution){
        let rawMaterialToken = this.props.match.params.token;
        this.props.createDevolution(preparedBy, failure, devolution)
        .then(() =>{
            this.setState({
                showToView:true,
                showToaster: false
            })
            this.props.history.push(`/rawmaterialnonconformity/${rawMaterialToken}`)
        }).catch(() =>{
            this.setState({
                showToaster:true,
                toasterMessage: <Translate id="common.errorToSave"/>,
                toasterVariant: "error",
            })
        });
    }

        /**
    * Get the card content
    *
    * @memberof Show
    */
   getCardContent() {
    if (this.props.isLoading === true) {
        return (
            <LoadingPage />
        )
    }
    else if (this.props.rawMaterial !== null) {
        return (
            <DevolutionForm  
                {...this.props}
                isSaving = {this.props.isSaving}
                canBeCreate={this.createDevolutionFromRawMaterialNononformity}
            /> 
        )
    }
}

    render(){
        return(
            <Card>
            <CardHeader
                avatar={
                    <Avatar>
                        <DevolutionIcon />
                    </Avatar>
                }
                title={<Typography variant="button" ><Translate id="devolutions.devolutionToSupplier"/></Typography>}
                subheader={<Typography variant="caption" color="textPrimary"><Translate id="common.createBy"/>{this.props.user.profile.name}
                 <br/><Translate id="common.creationDate"/>: {this.state.creationDate}</Typography>}
            />
            <CardContent>
                {this.getCardContent()}
            </CardContent>

            <Toaster 
                message = {this.state.toasterMessage}
                open = {this.state.showToaster}
                variant = {this.state.toasterVariant}
                onClose = {() => {this.setState({ showToaster:false})}}
            /> 

        </Card>
        )
    }
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state 
 */
function mapStateToProps(state){
    let user = state.oidc.user ? state.oidc.user: { profile: { name: "", email:"", user_type: ""  } };
    let rawMaterial = state.rawMaterialNonConformity.get("rawMaterial");
    return {
        user: user,
        isSaving: state.rawMaterialNonConformity.get('isSaving'),
        isLoading: state.rawMaterialNonConformity.get('isLoading'),
        rawMaterial: rawMaterial ? rawMaterial.toJS() : null,
    }
}

/**
 * Defines the actions injectes to the component 
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
    return {
        loadRawMaterialNonConformity:(token) =>{
            return dispatch(loadRawMaterialNonConformityFromBackEnd(token));
        },
        createDevolution:(preparedBy, failure, devolution) =>{
            return dispatch(createDevolutionFromBackEnd(preparedBy, failure, devolution))
        }
    }
}

const styles = theme => ({
    toolbar: {
        display: "flex"
    },
    actionsToolbar: {
        display: "flex"
    },
    searchInput: {
        marginTop: "5px"
    },
    button: {
        margin: theme.spacing.unit,
    },
    showingUsersCounter: {
        color: theme.palette.secondary.main
    },
    grow: {
        flexGrow: 1,
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    supplierBadge: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    }
});



export default withauthenticatedLayout(withRouter(withStyles(styles, { withTheme:true })(connect(mapStateToProps, mapDispatchToProps)(Create))));